<div class="search-container">
  <input #searchInput [ngClass]="{'closed': !isOpen, 'open' : isOpen }" type="text" class="form-control pull-right" placeholder="{{placeholder}}"
         [disabled]="!isOpen" [ngModel]="searchTerm" (ngModelChange)="onChange($event)" (keyup.enter)="onSearch()" [ngbTypeahead]="searchSuggestion" />
  <button class="btn btn-link clearBtn" [ngClass]="{'inputFieldButton-closed': !isOpen, 'inputFieldButton-open' : isOpen }" (click)="onClear()" [disabled]="!isOpen">
    <qpoint-icon [ngClass]="{'iconClosed': !isOpen, 'iconOpen' : isOpen }" icon="times"></qpoint-icon>
  </button>
  <button class="btn btn-link closeBtn" [ngClass]="{'inputFieldButton-closed': !isOpen, 'inputFieldButton-open' : isOpen }" (click)="onClose()" [disabled]="!isOpen">
    <qpoint-icon [ngClass]="{'iconClosed': !isOpen, 'iconOpen' : isOpen }" icon="arrow-right"></qpoint-icon>
  </button>

  <button class="btn btn-link searchBtn" (click)="onSearch()">
    <qpoint-icon *ngIf="!searchActive" [ngClass]="{'iconClosed': !isOpen, 'iconOpen' : isOpen }" icon="search"></qpoint-icon>
    <qpoint-loading-spinner [visible]="searchActive"></qpoint-loading-spinner>
  </button>
</div>
